/* Reuses the existing Google measurement ID after Shopify permits analytics. */
(function () {
  'use strict';
  if (window.__erpAnalyticsMounted) return;
  window.__erpAnalyticsMounted = true;
  const node=document.querySelector('[data-erp-google-id]');
  const id=node && node.dataset.erpGoogleId;
  if (!/^G-[A-Z0-9]+$/.test(id || '')) return;
  window.dataLayer=window.dataLayer || [];
  window.gtag=window.gtag || function () {window.dataLayer.push(arguments);};
  window.gtag('consent','default',{analytics_storage:'denied',ad_storage:'denied',ad_user_data:'denied',ad_personalization:'denied'});
  let loaded=false;
  function update() {
    let allowed=false;
    try {allowed=window.Shopify?.customerPrivacy?.analyticsProcessingAllowed() === true;} catch (_) {}
    window.gtag('consent','update',{analytics_storage:allowed?'granted':'denied',ad_storage:'denied',ad_user_data:'denied',ad_personalization:'denied'});
    if (!allowed || loaded) return;
    loaded=true;
    const tag=document.createElement('script');
    tag.async=true;tag.src='https://www.googletagmanager.com/gtag/js?id='+id;
    document.head.appendChild(tag);
    window.gtag('js',new Date());
    const page=window.ERPEnquiry?.context?.();
    const cleanPath=window.ERPEnquiry?.safePath?.(page?.path || '/',page?.kind || 'page') || '/';
    window.gtag('config',id,{send_page_view:false,page_location:'https://erpserveraccess.com'+cleanPath,page_referrer:'',page_title:'ERP Server Access',allow_google_signals:false,allow_ad_personalization_signals:false,campaign_source:'direct',campaign_medium:'(none)',campaign_name:'(not set)',campaign_term:'(not set)',campaign_content:'(not set)'});
  }
  document.addEventListener('visitorConsentCollected',update);
  document.addEventListener('erp:enquiry-ready',update);
  document.addEventListener('erp:enquiry-context-changed',update);
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',update,{once:true});else update();
})();
